import { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Polyline, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const html = (cls, inner = '') => L.divIcon({ className: '', html: `<div class="${cls}">${inner}</div>`, iconSize: [38, 38], iconAnchor: [19, 19] });
export const ICONS = {
  courier: html('pin-courier', '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0b0f17" stroke-width="2.5"><path d="M5 17h-2v-6l2-5h9l4 5h3v6h-2"/><circle cx="7.5" cy="17.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>'),
  home: html('pin-home', '<span></span>'),
  shop: html('pin-shop', '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#E8B84A" stroke-width="2.2"><path d="M3 9l1.5-5h15L21 9"/><path d="M3 9h18v2a3 3 0 0 1-6 0 3 3 0 0 1-6 0 3 3 0 0 1-6 0V9z"/><path d="M5 13v8h14v-8"/></svg>'),
};
export const DAKAR = [14.7167, -17.4677];

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    const pts = points.filter((p) => p && Number.isFinite(p[0]) && Number.isFinite(p[1]));
    if (!pts.length) return;
    if (pts.length === 1) map.setView(pts[0], 15, { animate: true });
    else map.fitBounds(L.latLngBounds(pts), { padding: [40, 40], maxZoom: 16, animate: true });
  }, [map, JSON.stringify(points)]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

export function MapView({ markers = [], trail = [], height = 'h-64', className = '', zoom = 12, center = DAKAR, testid = 'map' }) {
  const pts = markers.map((m) => m.pos);
  return (
    <div className={`${height} rounded-2xl overflow-hidden border border-white/10 map-dark ${className}`} data-testid={testid}>
      <MapContainer center={center} zoom={zoom} scrollWheelZoom={false} className="h-full w-full">
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' />
        {trail.length > 1 && <Polyline positions={trail} pathOptions={{ color: '#E8B84A', weight: 3, opacity: 0.7, dashArray: '6 8' }} />}
        {markers.map((m, i) => (
          <Marker key={m.key || i} position={m.pos} icon={ICONS[m.icon] || ICONS.home}>
            {m.label && <Popup>{m.label}</Popup>}
          </Marker>
        ))}
        <FitBounds points={pts} />
      </MapContainer>
    </div>
  );
}

export const locate = () => new Promise((res, rej) => {
  if (!navigator.geolocation) return rej(new Error('Géolocalisation non disponible sur cet appareil'));
  navigator.geolocation.getCurrentPosition((p) => res({ lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy }),
    (e) => rej(new Error(e.code === 1 ? 'Autorisez la localisation dans votre navigateur' : 'Position introuvable')), { enableHighAccuracy: true, timeout: 12000, maximumAge: 5000 });
});
